import ReactDOM from "react-dom/client";
import App from "./App";
import { msalInstance } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";
import "./theme/dx-material-TCP-theme-v1.css";
import "./styles/index.css";
import "./styles/library.css";
import "./styles/print.css";
import { Provider } from "react-redux";
import store from "./redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastContainer } from "react-toastify";
import config from "devextreme/core/config";
import { DX_LICENSE_KEY } from "./helper/devextreme-license";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import { ENVIRONMENT, SENTRY_DSN } from "./constants/constants";

config({ licenseKey: DX_LICENSE_KEY });

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 0, staleTime: 0 } },
});

const replaySessionConfigurationRate = ENVIRONMENT.toLocaleLowerCase().includes("prod") ? 0.1 : 0;
const replaysOnErrorConfigurationRate = ENVIRONMENT.toLocaleLowerCase().includes("prod") ? 1 : 0;

Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false,
    }),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: replaySessionConfigurationRate,
  replaysOnErrorSampleRate: replaysOnErrorConfigurationRate,
  environment: ENVIRONMENT,
  release: APP_VERSION,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <MsalProvider instance={msalInstance}>
    <QueryClientProvider client={queryClient}>
      <ToastContainer autoClose={2000} limit={4} draggable pauseOnHover />
      <Provider store={store}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} position={"right"} />
      </Provider>
    </QueryClientProvider>
  </MsalProvider>
);
